import { useState, useEffect } from "react";
import "./style.css";
import api from "../../../services/api.js";
import PopUp from "../../../componente/popup/index.jsx";
import { useAppContext } from '../../../context/AppContext.js';

function OpeReceberMissaoDesafio() {
    const { DateTime } = require("luxon");
    const [lista, setlista] = useState([]);
    const [abusca, setabusca] = useState("");

    const [edtcodigo, setedtcodigo] = useState(0);
    const [tipo, settipo] = useState("");

    const [isOpen, setIsOpen] = useState(false);

    const { selectedCompany, codassinante, accessKey } = useAppContext(); 

    const dt = new Date();

    const date1 =
        dt.getFullYear() +
        "-" +
        (dt.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        dt.getDate().toString().padStart(2, "0");

    const date2 =
        dt.getFullYear() +
        "-" +
        (dt.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        dt.getDate().toString().padStart(2, "0");

    const [dt1, setdt1] = useState(date1);
    const [dt2, setdt2] = useState(date2);

    const handleOpen = (cad) => {
        setedtcodigo(cad.codigo);
        settipo(cad.tipo);
        setIsOpen(true);
    };

    const handleConfirma = () => {
        setIsOpen(false);
        InformarConclusao();
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    function ListarMissaoDesafio() {
        api
            .get("/v1/operacoes/conclusaomissaodesafio", {
                params: {
                    busca: abusca,
                    codempresa: selectedCompany,
                    dt1,
                    dt2
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setlista(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    useEffect(
        function () {
            ListarMissaoDesafio();
        },
        [abusca, selectedCompany, dt1, dt2]
    );

    function InformarConclusao() {
        const dt = new Date();
        const date =
            dt.getFullYear() +
            "-" +
            (dt.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            dt.getDate().toString().padStart(2, "0");
        let time =
            dt.getHours().toString().padStart(2, "0") +
            ":" +
            dt.getMinutes().toString().padStart(2, "0");
        let dtcadastro = date + "T" + time;

        api
            .put(
                "/v1/operacoes/conclusaomissaodesafio",
                {
                    tipo,
                    dtconclusao: dtcadastro,
                    codigo: edtcodigo,
                    codempresa: selectedCompany,
                    codassinante
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },
                }
            )
            .then(() => {
                ListarMissaoDesafio();
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function FormataDataHora(props) {
        return props
            ? DateTime.fromISO(props)
                .plus({ hours: 3 })
                .toFormat("dd/MM/yyyy HH:mm:ss")
            : null;
    }

    return (
        <>
            <div className="app-container">
                <div className="container-fluid">
                    <div>
                        <div>
                            <PopUp isOpen={isOpen} onClose={handleClose}>
                                <h2>Verificação</h2>
                                <p>Tem certeza que deseja receber essa Missão/Desafio?</p>

                                <div className="row">
                                    <div className="col-12 mt-3 d-flex justify-content-end">
                                        <button
                                            className="btn btn-primary me-2"
                                            onClick={handleConfirma}
                                        >
                                            Sim
                                        </button>
                                        <button className="btn btn-danger" onClick={handleClose}>
                                            Não
                                        </button>
                                    </div>
                                </div>
                            </PopUp>
                        </div>
                    </div>

                    <div className="row">
                        <h1 className="ms-4">Receber Missão/Desafio</h1>
                        <p className="ms-4">Rotina para receber as missões ou desafios dos profissionais da empresa</p>
                        <hr />
                    </div>

                    <div className="row">
                        <div className="col-6">
                            <label className="d-block" htmlFor="busca">
                                Busque aqui
                            </label>
                            <input
                                type="text"
                                placeholder="Buscar por: Título ou nome do profissional"
                                name="busca"
                                id="busca"
                                className="form-control me-3"
                                value={abusca}
                                onChange={(e) => setabusca(e.target.value)}
                            />
                        </div>

                        <div className="col-sm-3">
                            <label htmlFor="dtlancamento" className="form-label">
                                Dt. Início
                            </label>
                            <input
                                type="date"
                                id="dtlancamento"
                                className="form-control"
                                placeholder="Dt. Lançamento"
                                value={dt1}
                                onChange={(e) => setdt1(e.target.value)}
                            />
                        </div>

                        <div className="col-sm-3">
                            <label htmlFor="dtlancamento" className="form-label">
                                Dt. Término
                            </label>
                            <input
                                type="date"
                                id="dtlancamento"
                                className="form-control"
                                placeholder="Dt. Lançamento"
                                value={dt2}
                                onChange={(e) => setdt2(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="row mt-3">
                        <hr />
                    </div>

                    <div className="row">
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th>Dt. Início</th>
                                    <th>Título</th>
                                    <th>Descrição</th>
                                    <th>Profissional</th>
                                    <th>Dt. Aceito</th>
                                    <th className="acao">Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {lista.map(function (item, index) {
                                    return (
                                        <tr key={index}>
                                            <th>{FormataDataHora(item.dtinicio)}</th>
                                            <th>{item.titulo}</th>
                                            <th>{item.descricao}</th>
                                            <th>{item.nome}</th>
                                            <th>{FormataDataHora(item.dtaceito)}</th>
                                            <th>
                                                <div className="d-flex justify-content-center">
                                                    <button
                                                        className="btn fa-solid fa-circle-check"
                                                        onClick={() => handleOpen(item)}
                                                    ></button>
                                                </div>
                                            </th>
                                        </tr>
                                    );
                                })}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th colSpan={6}>Quantidade de Registros: {lista.length}</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
}

export default OpeReceberMissaoDesafio;
